module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mycomplaints"
  }, [(_vm.showPage) ? _c('div', [(_vm.complaitintList.length > 0) ? _c('ul', {
    staticClass: "complaints_list"
  }, _vm._l((_vm.complaitintList), function(item) {
    return _c('li', [_c('div', {
      staticClass: "title",
      on: {
        "click": function($event) {
          return _vm.toGoodsList(item.supplierId, item.supplierShortName)
        }
      }
    }, [_c('div', {
      staticClass: "fl shop_icon",
      style: ({
        backgroundImage: 'url(' + item.shopIcon + ')'
      })
    }), _vm._v(" "), _c('div', {
      staticClass: "shop_info"
    }, [_c('span', {
      staticClass: "fl shop_name"
    }, [_vm._v(_vm._s(item.supplierShortName))]), _c('span', {
      staticClass: "fr state"
    }, [_vm._v(_vm._s(_vm.complainStatus[item.complainStatus]))])]), _vm._v(" "), _c('p', {
      staticClass: "time"
    }, [_vm._v(_vm._s(item.date))])]), _vm._v(" "), _c('div', {
      staticClass: "goods-list"
    }, [_c('ul', {
      staticStyle: {
        "margin-top": "0.2rem"
      }
    }, _vm._l((item.goodsList), function(order) {
      return _c('li', {
        staticStyle: {
          "margin-bottom": "0.12rem",
          "padding-top": "0",
          "padding-right": "0"
        }
      }, [_c('span', {
        staticClass: "fl"
      }, [_vm._v(_vm._s(order.name))]), _vm._v(" "), _c('span', {
        staticClass: "fr",
        staticStyle: {
          "color": "#9B9B9B"
        }
      }, [_vm._v("x " + _vm._s(order.buyNum))])])
    }), 0), _vm._v(" "), (item.omit) ? _c('div', {
      staticClass: "moreList"
    }, [_vm._v("···")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "price_info clearflow"
    }, [_c('p', {
      staticStyle: {
        "font-size": "0.28rem"
      }
    }, [_vm._v("总计"), _c('span', {
      staticClass: "pay_price",
      staticStyle: {
        "color": "#4A4A4A",
        "font-weight": "bold"
      }
    }, [_vm._v("￥" + _vm._s(item.amount))])]), _vm._v(" "), _c('span', {
      staticClass: "fr btn_check",
      on: {
        "click": function($event) {
          return _vm.toCheckComplaints(item.complaintId)
        }
      }
    }, [_vm._v("查看投诉")])])])
  }), 0) : _c('div', {
    staticClass: "no-info"
  }, [_vm._m(0)])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "no-goods"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/empty-01.png")
    }
  }), _vm._v(" "), _c('p', [_vm._v("这里什么都没有")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-790d8252","hasScoped":false}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/pages/MyComplaints.vue
// module id = 451
// module chunks = 7